import { useState } from 'react';
import { useAccordionButton } from 'react-bootstrap';
import { toast } from 'react-toastify';
import type { IFaqType } from '../../models/profile';
import { getFAQData } from '../../services/faq/faq-services';
import type { customToggleProps } from '../../types/propTypes';

export const FAQPageHook = () => {
  const [activeKey, setActiveKey] = useState('0');
  const [faqArray, setFaqArray] = useState<IFaqType[]>();

  const fetchData = async () => {
    try {
      document.getElementById('loading')?.classList.add('manual-loading');
      const faqData = await getFAQData();
      setFaqArray(faqData.Data.faq || []);
    } catch (error) {
      toast.error(error.response?.message || error.toString());
    } finally {
      document.getElementById('loading')?.classList.remove('manual-loading');
    }
  };

  const handleActiveKey = (key: number) => {
    const newActiveKey = activeKey == key.toString() ? '' : key.toString();
    setActiveKey(newActiveKey);
  };

  const CustomToggle = ({ children, eventKey }: customToggleProps) => {
    const decoratedOnClick = useAccordionButton(eventKey, () => handleActiveKey(parseInt(eventKey)));
    return (
      <span
        className={activeKey === eventKey.toString() ? 'faq-card-title' : 'faq-card-title collapsed'}
        onClick={decoratedOnClick}
      >
        {children}
      </span>
    );
  };

  return {
    activeKey,
    faqArray,
    fetchData,
    handleActiveKey,
    CustomToggle,
  };
};
